import { HttpError } from '../clients/omni-core/models';

const isHttpError = (error: unknown): error is HttpError => {
  return typeof error === 'object' && error !== null && 'status' in error;
};

export const toHttpError = (error: unknown): HttpError | null => {
  if (!isHttpError(error)) {
    return null;
  }
  return error as HttpError;
};
